import * as types from './types';
import { createAction } from '../../models/redux/CreateAction';

export const clearCustomerData = () => {
  return createAction(types.CLEAR_CUSTOMER_DATA);
};

export const fetchAbsence = (payload: { id: number }) => {
  return createAction(types.FETCH_ABSENCE_REQUEST, payload);
};

export const fetchMyCustomers = (payload: { filter: {} }) => {
  return createAction(types.GET_MY_CUSTOMERS_REQUEST, payload);
};

export const postAbsence = payload => {
  return createAction(types.POST_ABSENCE_REQUEST, payload);
};

export const fetchMemos = (payload: { id: number }) => {
  return createAction(types.FETCH_MEMOS_REQUEST, payload);
};
